import { useEffect, useState } from "react";

interface ToastMessage {
  id: number;
  message: string;
  type: "info" | "success" | "error";
}

const toastListeners: Array<(msg: ToastMessage) => void> = [];

export function showToast(message: string, type: "info" | "success" | "error" = "info") {
  const toast: ToastMessage = {
    id: Date.now() + Math.random(),
    message,
    type,
  };
  toastListeners.forEach((listener) => listener(toast));
}

export default function Toast() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const listener = (msg: ToastMessage) => {
      setToasts((prev) => [...prev, msg]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== msg.id));
      }, 3000);
    };
    toastListeners.push(listener);
    return () => {
      const index = toastListeners.indexOf(listener);
      if (index !== -1) toastListeners.splice(index, 1);
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-3">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`glass-card px-5 py-3.5 rounded-xl flex items-center gap-3 min-w-[280px] max-w-sm animate-fade-in-up shadow-lg ${
            toast.type === "success"
              ? "border-primary-400/20 bg-primary-500/10"
              : toast.type === "error"
              ? "border-accent-400/20 bg-accent-500/10"
              : "border-foreground-100/10"
          }`}
        >
          <div
            className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
              toast.type === "success"
                ? "bg-primary-500/15 text-primary-300"
                : toast.type === "error"
                ? "bg-accent-500/15 text-accent-300"
                : "bg-foreground-100/5 text-foreground-300"
            }`}
          >
            <i
              className={`text-base ${
                toast.type === "success"
                  ? "ri-check-line"
                  : toast.type === "error"
                  ? "ri-error-warning-line"
                  : "ri-information-line"
              }`}
            />
          </div>
          <p className="text-sm text-foreground-100 font-medium">{toast.message}</p>
          <button
            type="button"
            onClick={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
            className="ml-auto p-1 text-foreground-400/40 hover:text-foreground-200 transition-colors cursor-pointer"
            aria-label="Cerrar notificación"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>
      ))}
    </div>
  );
}